export const THROTTLE_TIME_AUTOCOMPLETION = 700
